import { create } from 'zustand';

/**
 * Whether the V2 frame (`ShellLayout`'s `FramedShell`) is currently mounted.
 *
 * A zustand store rather than a React context because the second consumer
 * (`useActionsDockSync`, U3b) lives in `RailDock`, which mounts via
 * `EnrollQueueDock` as a SIBLING of the `<Outlet/>` that holds `ShellLayout`
 * (AppRouter.tsx), so no provider inside `ShellLayout` can reach it.
 *
 * Consumers: `useActionsDockSync`, `RailDock`, `useDockUrlSync` and the chat
 * sessions provider.
 */
export type ShellFrameState = { frameActive: boolean };

export const initialState: ShellFrameState = { frameActive: false };

export const useShellFrameStore = create<ShellFrameState>(() => initialState);

/** True while the V2 frame is mounted around the current route. */
export function useIsFramed(): boolean {
  return useShellFrameStore((s) => s.frameActive);
}
